import { AlertColor, useMediaQuery, useTheme } from '@mui/material';
import Notification from 'components/Notification';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDrawerWidth } from 'utils/validators/HelperFunctions';
import DrawerMenu from '../../../components/DrawerMenu';
import Login from '../../../screens/Authentication/Login';
import {
  drawerStateGlobal,
  openAuthenticationDrawer,
  setDrawerStateGlobal,
  setOpenAuthenticationDrawer,
} from '../../../utils/redux/reducer/authentication-slice';
import ForgotPassword from '../ForgotPassword';
import SignUp from '../SignUp';

const AuthenticationDrawer = () => {
  const theme = useTheme();
  const screenSizeDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const screenSizeDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const screenSizeUpLg = useMediaQuery(theme.breakpoints.up('lg'));
  // drawerState 1 = Login
  // drawerState 2 = Forgot Password
  // drawerState 3 = Sign Up
  const drawerState = useSelector(drawerStateGlobal);
  // const [drawerState, setDrawerState] = useState<1 | 2 | 3>(1);
  const setDrawerState = (val: any) => {
    dispatch(setDrawerStateGlobal(val))
  }
  const openDrawer = useSelector(openAuthenticationDrawer);
  const dispatch = useDispatch();
  const [message, setMessage] = React.useState<{
    display: boolean;
    severity: AlertColor | null;
    message: any;
  }>({
    display: false,
    severity: null,
    message: "",
  });
  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };


  const handleClose = () => {
    setDrawerState(1);
    dispatch(setOpenAuthenticationDrawer(false));
  };

  const RenderedComponent = () => {
    if (drawerState === 1) {
      return <Login handleClose={handleClose} setDrawerState={setDrawerState} />;
    } else if (drawerState === 2) {
      return <ForgotPassword handleClose={handleClose} setDrawerState={setDrawerState} setDrawerMessage={setMessage} />;
    } else {
      return <SignUp setDrawerState={setDrawerState} setMessage={setMessage} />;
    }
  };



  return (
    <>
      {message && message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <DrawerMenu
        open={openDrawer}
        handleClose={handleClose}
        width={getDrawerWidth(screenSizeDownSm, screenSizeDownMd, screenSizeUpLg)}
        drawerState={drawerState}>
        <RenderedComponent />
      </DrawerMenu>
    </>
  );
};

export default AuthenticationDrawer;
